<script>
export default {
  name: 'avaliacao-header',
  props: {
    pessoa: Object
  }
}
</script>

<template>
  <div class="avaliacao-header">
    <header class="header-bar">
      <div class="logo">
        <figure>
          <figcaption>Avaliação</figcaption>
          <img src="https://urcamp.edu.br/site/img/logos/logo-branco.png" alt="">
        </figure>
      </div>
      <div class="navigation" v-if="pessoa.nome">
        <nav class="menu-icons">
          <div class="user-info">
            <div><span class="name">{{ pessoa.nome }}</span></div>
            <div><strong>{{ pessoa.id }}</strong></div>
          </div>
          <div class="dropmenu-header">
            <div class="item-icon user">
              {{ pessoa.sigla }}
            </div>
          </div>
        </nav>
      </div>
    </header>
  </div>
</template>

<style lang="scss">
.avaliacao-header {
  height: 80px;

  .header-bar {
    width: 100vw;
    height: 80px;
    background: rgba(51, 68, 61, 1);
    background: -moz-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
    background: -webkit-gradient(left top, right top, color-stop(0%, rgba(51, 68, 61, 1)), color-stop(100%, rgba(59, 80, 71, 1)));
    background: -webkit-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
    background: -o-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
    background: -ms-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
    background: linear-gradient(to right, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#33443d', endColorstr='#3b5047', GradientType=1);
    border-bottom: 5px solid #909E48;
    -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: space-between;

    > .logo {
      margin: 0;
      display: block;
      width: 200px;
      padding: 10px;
      text-decoration: none;
      background-color: #384f45;
      height: 75px;

      figcaption {
        text-align: center;
        color: #FFF;
        font-size: 18px;
        font-weight: 300;
      }

      img {
        position: relative;
        top: -15px;
        left: -5px;
        display: block;
        margin: 0 auto;
        max-width: 100%;
        max-height: 44px;
      }
    }

    > .navigation {
      padding-right: 30px;
    }

    .navigation {
      .menu-icons {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 75px;

        .dropmenu-header {
          width: 65px;
        }

        .item-icon {
          width: 65px;
          height: 75px;
          line-height: 75px;
          text-align: center;
          color: #909E48;
          font-size: 28px;
          position: relative;

          &.user {
            background-color: rgba(0, 0, 0, 0.2);
            color: #FFF;
            text-decoration: none;
            font-size: 20px;
            font-weight: bold;
            border-radius: 50%;
            width: 55px;
            height: 55px;
            line-height: 55px;
            margin: 0;
            text-align: center;
          }
        }
      }

      .user-info {
        font-size: 16px;
        padding-right: 12px;
        color: rgba(255, 255, 255, 0.7);
        text-align: center;
        line-height: 18px;

        .name {
          color: #FFF;
        }

        strong {
          color: #bed160;
          font-weight: 600;
          font-size: 14px;
        }
      }

      .user-avatar {
        width: 55px;
        height: 55px;
        border-radius: 50%;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        border: 2px solid #4b6a5d;
        cursor: pointer;
      }
    }
  }
}

@media all and (max-width: 1024px) {
  .avaliacao-header {
    .header-bar {
      .logo {
        width: 170px;
      }
    }
  }
}

@media all and (max-width: 768px) {
  .avaliacao-header {
    height: 60px;

    .header-bar {
      height: 60px;

      > .logo {
        width: 160px;
        height: 55px;
        padding: 5px;

        figcaption {
          font-size: 14px;
        }

        img {
          max-width: 94%;
        }
      }

      .navigation {
        padding-right: 10px;

        .menu-icons {
          .dropmenu-header {
            width: 45px;
          }

          .user-avatar {
            width: 40px;
            height: 40px;
          }

          .item-icon.user {
            width: 40px;
            height: 40px;
            line-height: 40px;
            font-size: 17px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?5335866e